import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const AddParty = ({setResponse, isModal, setShowAddParty, onSuccess}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    gst: '',
    p_type: 'Customer'
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };

const indianStates = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh'
];


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch('https://api.siddhabhairabistore.com/add-party', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!res.ok) throw new Error('Failed to add party');
            setFormData({
    name: '',
    mobile: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    gst: ''
            });
      setResponse({ message: `${formData.p_type} Added successfully.`, status: 'success' });
      setTimeout(() => setResponse(''), 2000);
      if(isModal){
        onSuccess?.();
        setShowAddParty(false);
}
    } catch (error) {
      setResponse({ message: 'Failed to add party.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className='my-4'>
        <div className='px-4'>
          <div className='d-flex justify-content-between'>
            <p className='page-title'>Add New Party</p>
            {!isModal &&
            <button className='close-btn' onClick={() => navigate(-1)}>Go Back</button>}
          </div>

          <form className="row g-3 bg-white rounded-2 mt-3" onSubmit={handleSubmit}>
            <div className="col-md-6">
              <label htmlFor="name" className="profile-label">Party Name</label>
              <input
                type="text"
                className="product-control"
                id="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="mobile" className="profile-label">Mobile</label>
              <input
                type="tel"
                className="product-control"
                id="mobile"
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="email" className="profile-label">Email</label>
              <input
                type="email"
                className="product-control"
                id="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="gst" className="profile-label">GST Number</label>
              <input
                type="text"
                className="product-control"
                id="gst"
                value={formData.gst}
                onChange={handleChange}
              />
            </div>

            <div className="col-12">
              <label htmlFor="address" className="profile-label">Address</label>
              <textarea
                className="product-control"
                id="address"
                rows="2"
                value={formData.address}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-md-6">
              <label htmlFor="city" className="profile-label">City</label>
              <input
                type="text"
                className="product-control"
                id="city"
                value={formData.city}
                onChange={handleChange}
              />
            </div>

         <div className='col-lg-6'>
            <label className='profile-label'>State</label>
            <select
              name='state'
              id='state'
              className='product-control'
              value={formData.state}
              onChange={handleChange}
            >
              <option value="">Select State</option>
              {indianStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

            <div className="col-lg-6">
              <label htmlFor="pincode" className="profile-label">Pincode</label>
              <input
                type="text"
                className="product-control"
                id="pincode"
                value={formData.pincode}
                onChange={handleChange}
              />
            </div>

                     <div className='col-lg-6'>
            <label className='profile-label'>Select Type</label>
            <select
              name='p_type'
              id='p_type'
              className='product-control'
              value={formData.p_type}
              onChange={handleChange}
            >
              <option value="Party">Party</option>
            
                <option value="Customer">
Customer
                </option>
              
            </select>
          </div>


            <div className="col-12 text-end">
              <button type="submit" className="edit-btn">
                Submit Details
              </button>
            </div>
          </form>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default AddParty;
